// src/components/Common/GlobalFeedback.jsx
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideFeedback } from '../../Redux/UI/uiFeedbackSlice';
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaTimes,
} from 'react-icons/fa';
import '../../Stylesheets/Public/GlobalFeedback.css';

const GlobalFeedback = () => {
  const dispatch = useDispatch();
  const { open, type, title, message, id } = useSelector((s) => s.uiFeedback);

  // auto-close after 4s whenever a new message appears
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => dispatch(hideFeedback()), 4000);
    return () => clearTimeout(t);
  }, [open, id, dispatch]);

  if (!open) return null;

  const icon = (() => {
    switch (type) {
      case 'success':
        return <FaCheckCircle />;
      case 'error':
        return <FaExclamationTriangle />;
      case 'warning':
        return <FaExclamationTriangle />;
      default:
        return <FaInfoCircle />;
    }
  })();

  const label = (() => {
    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Heads up';
      default:
        return 'Notice';
    }
  })();

  return (
    <div className={`global-feedback global-feedback--${type}`}>
      <div className="global-feedback-accent" />

      <div className="global-feedback-main">
        <div className="global-feedback-left">
          <div className={`global-feedback-icon-pill global-feedback-icon-pill--${type}`}>
            {icon}
          </div>
        </div>

        <div className="global-feedback-content">
          <div className="global-feedback-header-row">
            <span className={`global-feedback-label global-feedback-label--${type}`}>
              {label}
            </span>
            {title && <div className="global-feedback-title">{title}</div>}
          </div>
          {message && <div className="global-feedback-message">{message}</div>}
        </div>

        <button
          className="global-feedback-close"
          onClick={() => dispatch(hideFeedback())}
          aria-label="Close notification"
        >
          <FaTimes />
        </button>
      </div>

      <div className={`global-feedback-timer global-feedback-timer--${type}`}>
        <div className="global-feedback-timer-fill" />
      </div>
    </div>
  );
};

export default GlobalFeedback;
